var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConvertMonarch3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 58,
    viewBox: "0 0 60 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 3C45.3594 3 57 14.6407 57 29C57 43.3594 45.3594 55 31 55C16.6406 55 5 43.3594 5 29C5 14.6407 16.6406 3 31 3Z",
    stroke: "#E3000F",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8198 38.6001C40.3055 38.6001 47.1847 40.0333 47.1847 41.8013C47.1847 43.569 40.3055 45.0022 31.8198 45.0022C23.3339 45.0022 16.4548 43.569 16.4548 41.8013C16.4548 40.0333 23.3339 38.6001 31.8198 38.6001Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8198 38.6001C40.3055 38.6001 47.1847 40.0333 47.1847 41.8013C47.1847 43.569 40.3055 45.0022 31.8198 45.0022C23.3339 45.0022 16.4548 43.569 16.4548 41.8013C16.4548 40.0333 23.3339 38.6001 31.8198 38.6001Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1348 19.8928H46.9156V42.4407H16.1348V19.8928Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5257 16.534C40.0115 16.534 46.8906 17.9671 46.8906 19.7352C46.8906 21.503 40.0115 22.9362 31.5257 22.9362C23.0399 22.9362 16.1611 21.503 16.1611 19.7352C16.1611 17.9671 23.0399 16.534 31.5257 16.534Z",
    fill: "#D9DADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5257 16.534C40.0115 16.534 46.8906 17.9671 46.8906 19.7352C46.8906 21.503 40.0115 22.9362 31.5257 22.9362C23.0399 22.9362 16.1611 21.503 16.1611 19.7352C16.1611 17.9671 23.0399 16.534 31.5257 16.534Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.48506 51.0169L3.30932 50.425L4.92772 49.1132C5.72786 48.4702 6.12772 47.6917 6.12772 46.777C6.12772 46.441 6.00783 46.1398 5.7705 45.8704C5.5305 45.6013 5.25052 45.4651 4.92772 45.4651H4.86116C4.47716 45.4783 4.16797 45.6493 3.9333 45.9799C3.7013 46.3102 3.53572 46.6598 3.44506 47.025C3.35466 47.3878 3.30932 47.6251 3.30932 47.7343L2.8293 47.3372C2.8293 47.257 2.9385 46.9637 3.15437 46.4569C3.37317 45.9478 3.65852 45.4837 4.01305 45.0597C4.36532 44.636 4.76782 44.425 5.21569 44.425C5.57849 44.425 5.89862 44.5105 6.18102 44.6782C6.46102 44.8465 6.68519 45.0758 6.85306 45.3665C7.01853 45.6598 7.11719 45.9799 7.14932 46.3291C7.14932 46.7638 7.01852 47.1985 6.75972 47.6383C6.49852 48.0757 6.2105 48.457 5.89863 48.7852C5.58383 49.1105 5.41039 49.273 5.37332 49.273C5.40506 49.2703 5.45837 49.2625 5.53584 49.2545C5.61064 49.2466 5.70102 49.2435 5.80529 49.2435C6.23729 49.2435 6.62129 49.3717 6.95169 49.6306C7.28236 49.8865 7.45583 50.3717 7.46903 51.0838C7.46903 51.8572 7.2665 52.5797 6.85863 53.2491C6.45317 53.9158 5.91452 54.4465 5.24519 54.841C4.57586 55.2357 3.87704 55.4329 3.14904 55.4329C2.91704 55.4329 2.71171 55.417 2.53865 55.3849C2.36251 55.3532 2.28237 55.3342 2.3013 55.3342V54.745C2.5197 54.8837 2.82397 54.9529 3.21597 54.9529C3.67171 54.9529 4.1333 54.8305 4.59704 54.5825C5.06117 54.3342 5.44519 53.9744 5.74905 53.5024C6.05332 53.0302 6.20519 52.4732 6.20519 51.8329C6.20519 51.3772 6.13036 51.0117 5.98103 50.7398C5.83436 50.4652 5.50369 50.3078 4.98929 50.2651C4.77316 50.2651 4.55196 50.3211 4.32783 50.4303C4.10116 50.5395 3.90386 50.6597 3.73599 50.7905C3.56786 50.9209 3.48506 50.9957 3.48506 51.0169Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1488 45.8567C13.2671 45.8567 14.1739 46.868 14.1739 48.1154C14.1739 49.363 13.2671 50.374 12.1488 50.374C11.0304 50.374 10.1238 49.363 10.1238 48.1154C10.1238 46.868 11.0304 45.8567 12.1488 45.8567Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1488 45.8567C13.2671 45.8567 14.1739 46.868 14.1739 48.1154C14.1739 49.363 13.2671 50.374 12.1488 50.374C11.0304 50.374 10.1238 49.363 10.1238 48.1154C10.1238 46.868 11.0304 45.8567 12.1488 45.8567Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2266 54.1128H8.09863C8.09863 51.9623 9.94674 50.2184 12.2266 50.2184C14.5063 50.2184 16.3546 51.9623 16.3546 54.1128H12.2266Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2266 54.1128H8.09863C8.09863 51.9623 9.94674 50.2184 12.2266 50.2184C14.5063 50.2184 16.3546 51.9623 16.3546 54.1128H12.2266Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-472 -908)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertMonarch3);
export default __webpack_public_path__ + "static/media/convert_monarch3.c1d16a640290f827a64962479068e1f6.svg";
export { ForwardRef as ReactComponent };